import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadCommitteeMeetingAttendance: ICommitteeMeetingAttendanceLoadActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_LOAD,
            committeeId
        }
    },
    LoadCommitteeMeetingAttendanceById: ICommitteeMeetingAttendanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_ID,
            id
        }
    },
    LoadCommitteeMeetingAttendanceByCommitteeMeetingId: ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdActionCreator = (committeeMeetingId) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_COMMITTEEMEETING_ID,
            committeeMeetingId
        }
    },
    LoadSuccess: ICommitteeMeetingAttendanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ICommitteeMeetingAttendanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveCommitteeMeetingAttendance: ICommitteeMeetingAttendanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ICommitteeMeetingAttendanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ICommitteeMeetingAttendanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateCommitteeMeetingAttendance: ICommitteeMeetingAttendanceCreateActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_CREATE,
            committeeId
        }
    },
    CreateSuccess: ICommitteeMeetingAttendanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ICommitteeMeetingAttendanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateCommitteeMeetingAttendance: ICommitteeMeetingAttendanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ICommitteeMeetingAttendanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ICommitteeMeetingAttendanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ICommitteeMeetingAttendanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ICommitteeMeetingAttendanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_COMMITTEEMEETINGATTENDANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD = "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD",
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_ID = "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_ID",
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_COMMITTEEMEETING_ID = "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_COMMITTEEMEETING_ID",
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_SUCCESS = "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_SUCCESS",
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_FAILURE = "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_FAILURE",

    ACTION_COMMITTEEMEETINGATTENDANCE_SAVE = "ACTION_COMMITTEEMEETINGATTENDANCE_SAVE",
    ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_SUCCESS = "ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_SUCCESS",
    ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_FAILURE = "ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_FAILURE",

    ACTION_COMMITTEEMEETINGATTENDANCE_CREATE = "ACTION_COMMITTEEMEETINGATTENDANCE_CREATE",
    ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_SUCCESS = "ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_SUCCESS",
    ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_FAILURE = "ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_FAILURE",

    ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE = "ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE",
    ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_SUCCESS = "ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_SUCCESS",
    ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_FAILURE = "ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_FAILURE",

    ACTION_COMMITTEEMEETINGATTENDANCE_CLEAR = "ACTION_COMMITTEEMEETINGATTENDANCE_CLEAR",

    ACTION_COMMITTEEMEETINGATTENDANCE_FILTER = "ACTION_COMMITTEEMEETINGATTENDANCE_FILTER";

export interface ICommitteeMeetingAttendanceLoadAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD";
    committeeId: number;
}

export interface ICommitteeMeetingAttendanceLoadActionCreator {
    (committeeId: number): ICommitteeMeetingAttendanceLoadAction;
}

export interface ICommitteeMeetingAttendanceLoadSuccessAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_SUCCESS";
    formData: Dtos.CommitteeMeetingAttendance | Dtos.CommitteeMeetingAttendance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingAttendanceLoadSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeetingAttendance | Dtos.CommitteeMeetingAttendance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMeetingAttendanceLoadSuccessAction;
}

export interface ICommitteeMeetingAttendanceLoadFailureAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingAttendanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingAttendanceLoadFailureAction;
}

export interface ICommitteeMeetingAttendanceLoadByIdAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_ID";
    id: number;
}

export interface ICommitteeMeetingAttendanceLoadByIdActionCreator {
    (id: number): ICommitteeMeetingAttendanceLoadByIdAction;
}

export interface ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_COMMITTEEMEETING_ID";
    committeeMeetingId: number;
}

export interface ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdActionCreator {
    (committeeMeetingId: number): ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdAction;
}

export interface ICommitteeMeetingAttendanceSaveAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_SAVE";
    formData: Dtos.CommitteeMeetingAttendance;

}

export interface ICommitteeMeetingAttendanceSaveActionCreator {
    (
        formData: Dtos.CommitteeMeetingAttendance
    ): ICommitteeMeetingAttendanceSaveAction;
}

export interface ICommitteeMeetingAttendanceSaveSuccessAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_SUCCESS";
    formData: Dtos.CommitteeMeetingAttendance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingAttendanceSaveSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeetingAttendance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMeetingAttendanceSaveSuccessAction;
}

export interface ICommitteeMeetingAttendanceSaveFailureAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMeetingAttendanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingAttendanceSaveFailureAction;
}

export interface ICommitteeMeetingAttendanceCreateAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_CREATE",
    committeeId: number
}

export interface ICommitteeMeetingAttendanceCreateActionCreator {
    (committeeId: number): ICommitteeMeetingAttendanceCreateAction
}

export interface ICommitteeMeetingAttendanceCreateSuccessAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_SUCCESS";
    formData: Dtos.CommitteeMeetingAttendance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ICommitteeMeetingAttendanceCreateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeetingAttendance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ICommitteeMeetingAttendanceCreateSuccessAction;
}

export interface ICommitteeMeetingAttendanceCreateFailureAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMeetingAttendanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingAttendanceCreateFailureAction;
}

export interface ICommitteeMeetingAttendanceValidateAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE";
    formData: Dtos.CommitteeMeetingAttendance;

}

export interface ICommitteeMeetingAttendanceValidateActionCreator {
    (
        formData: Dtos.CommitteeMeetingAttendance
    ): ICommitteeMeetingAttendanceValidateAction;
}

export interface ICommitteeMeetingAttendanceValidateSuccessAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_SUCCESS";
    formData: Dtos.CommitteeMeetingAttendance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMeetingAttendanceValidateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMeetingAttendance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMeetingAttendanceValidateSuccessAction;
}

export interface ICommitteeMeetingAttendanceValidateFailureAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMeetingAttendanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMeetingAttendanceValidateFailureAction;
}

export interface ICommitteeMeetingAttendanceClearAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ICommitteeMeetingAttendanceClearActionCreator {
    (propertiesToClear?: string[]): ICommitteeMeetingAttendanceClearAction;
}

export interface ICommitteeMeetingAttendanceFilterActionCreator {
    (formFilter: IFormFilter): ICommitteeMeetingAttendanceFilterAction;
}

export interface ICommitteeMeetingAttendanceFilterAction {
    type: "ACTION_COMMITTEEMEETINGATTENDANCE_FILTER";
    formFilter: IFormFilter;
}


export type CommitteeMeetingAttendanceAction =
    ICommitteeMeetingAttendanceLoadAction |
    ICommitteeMeetingAttendanceLoadByIdAction |
    ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdAction |
    ICommitteeMeetingAttendanceLoadFailureAction |
    ICommitteeMeetingAttendanceLoadSuccessAction |
    ICommitteeMeetingAttendanceSaveAction |
    ICommitteeMeetingAttendanceSaveSuccessAction |
    ICommitteeMeetingAttendanceSaveFailureAction |
    ICommitteeMeetingAttendanceCreateAction |
    ICommitteeMeetingAttendanceCreateSuccessAction |
    ICommitteeMeetingAttendanceCreateFailureAction |
    ICommitteeMeetingAttendanceValidateAction |
    ICommitteeMeetingAttendanceValidateSuccessAction |
    ICommitteeMeetingAttendanceValidateFailureAction |
    ICommitteeMeetingAttendanceClearAction | 
    ICommitteeMeetingAttendanceFilterAction;
